/*
 * @Author: edvardchen
 * @Date:   2017-05-06 22:45:36
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-04-21 09:48:32
 */

// @flow
import _ from 'lodash';

import querystring from 'query-string';

import { post } from './fetch';

import { isomorphicConfig } from '../utility';

import { authenticate } from '../ducks/login';

export * from '../ducks/user';

export const clearProfile = (level: number = 0) =>
  post('/api/user/clearprofile', {
    body: querystring.stringify({ level }),
  });

export const sendAuthenticate = (userInfo: Object) =>
  post('/api/user/authenticate', {
    body: userInfo,
  });

export function logout() {
  return post('/api/user/logout');
}

const coolboot = (method) => post(`/api/user/coolboot/${method !== 'POST' ? method : ''}`);

export function getCoolBootStatus() {
  return coolboot('POST');
}

export function setCoolBoot() {
  return coolboot('PUT');
}
export function unsetCoolBoot() {
  return coolboot('DELETE'); // 安卓莫名原因不支持 delete method
}

export async function loginQB(): Promise<*> {
  if (!__CLIENT__) {
    return;
  }
  const showLoginPanel = _.get(window, 'browser.login.showLoginPanel');
  if (!showLoginPanel) {
    return;
  }
  return new Promise((resolve, reject) => {
    showLoginPanel(
      () => {
        authenticate().then(resolve, reject);
      },
      (err) => {
        const toast = _.get(window, 'browser.app.toast');
        toast && toast(err);
        reject(err);
      },
      {
        appID: Number(_.get(isomorphicConfig, 'login.appId')),
      },
    );
  });
}

export const getGSPProxy = () => post('/api/user/gspproxy');
export const getPushWelfare = (data: Object) =>
  post('/api/user/getWelfare', {
    body: {
      data: JSON.stringify(data),
    },
  });
export const getProfileMatch = () => post('/api/user/profileMatch');
